import * as isomorphicLocalStorage from 'lib/storage/isomorphicLocalStorage'
import { EmptyArray, take, uniqueBy } from 'lib/array/arrayUtils'
import { RECENT_AIRPORTS_LIMIT } from 'constants/search'

const RECENT_AIRPORTS_KEY_PREFIX = 'flight-recent-airports'

function getStorageKey(memberId?: string): string | undefined {
  return memberId ? `${RECENT_AIRPORTS_KEY_PREFIX}-${memberId}` : undefined
}

export function getRecentAirports(memberId?: string): Array<App.AirportLocation> {
  const key = getStorageKey(memberId)
  if (!key) return EmptyArray

  return isomorphicLocalStorage.get(key) ?? EmptyArray
}

export function saveRecentAirports(
  airports: Array<App.AirportLocation | undefined>,
  memberId?: string,
) {
  const key = getStorageKey(memberId)
  if (!key) return

  const searched = airports.filter((airport): airport is App.AirportLocation => !!airport?.airportCode)
  const unique = uniqueBy([...searched, ...getRecentAirports(memberId)], airport => airport.airportCode)
  isomorphicLocalStorage.set(key, take(unique, RECENT_AIRPORTS_LIMIT))
}
